import { useState, useEffect } from "react";
import { hotjar } from "react-hotjar";
var HOTJAR_TRACKING_ID = process.env.HOTJAR_TRACKING_ID;
var HOTJAR_SNIPPET_VERSION = process.env.HOTJAR_SNIPPET_VERSION;
var isProduction = process.env.IS_PRODUCTION;
export var useHotjar = function () {
    var _a = useState(false), initialized = _a[0], setInitialized = _a[1];
    useEffect(function () {
        if (!window.location.href.includes("localhost") && !!isProduction) {
            hotjar.initialize(Number(HOTJAR_TRACKING_ID), Number(HOTJAR_SNIPPET_VERSION));
            setInitialized(true);
        }
    }, []);
    return { initialized: initialized };
};
